module.exports = __webpack_public_path__ + "img/img-15.79a02f1d.png";